(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mpm-pastilles"] && !Shopify.designMode) return;
  try {
    /*
   * Maison Porte-Manteau : pastilles et bulles de couleur (02/11/2026). Sans dépendance.
   * Fiche produit : le libellé « Couleur : X » suit la pastille cochée sans attendre le serveur (Horizon
   * recharge ensuite le sélecteur avec la même valeur).
   * Cartes : survol d'une bulle à la souris, toucher ou clavier (boutons radio) : la carte passe à cette couleur
   * (photo en fondu, 2e photo au survol, liens ?variant=, ajout rapide). Le choix reste après le survol, pour
   * que le clic sur la carte ouvre la fiche dans cette couleur. Un toucher sur une bulle n'ouvre pas la fiche
   * (Horizon ne navigue pas sur un champ ou une étiquette).
   */
  if (!window.mpmPastilles) {
    window.mpmPastilles = true;

    const DUREE_FONDU = 200;
    let jeton = 0;
    let niveau = 1;
    /** @type {WeakMap<Element, Map<string, HTMLImageElement>>} */
    const photosSurvol = new WeakMap();

    /** @param {HTMLInputElement} champ */
    const majLibelle = (champ) => {
      const groupe = champ.closest('.mpm-couleur');
      const valeur = groupe ? groupe.querySelector('[data-mpm-couleur-valeur]') : null;
      if (valeur && valeur.textContent !== champ.value) valeur.textContent = champ.value;
    };

    /**
     * Rappel quand la photo est chargée (ou en erreur) ; tout de suite si c'est déjà fait.
     * @param {HTMLImageElement} img
     * @param {() => void} rappel
     */
    const quandChargee = (img, rappel) => {
      if (img.hasAttribute('data-mpm-charge')) {
        rappel();
        return;
      }
      img.addEventListener('load', rappel, { once: true });
      img.addEventListener('error', rappel, { once: true });
    };

    /**
     * Photo vedette d'une couleur dans le calque, créée depuis son modèle à la 1re demande. Chargement immédiat
     * (pas différé : sizes reprend alors la taille de la carte) ; data-mpm-charge quand elle est prête.
     * @param {HTMLElement} calque
     * @param {string} index
     * @returns {HTMLImageElement | null}
     */
    const photoTeinte = (calque, index) => {
      for (const img of calque.querySelectorAll(':scope > img[data-mpm-teinte]')) {
        if (img instanceof HTMLImageElement && img.dataset.mpmTeinte === index) return img;
      }
      const modele = calque.querySelector(`template[data-mpm-teinte="${index}"]`);
      const source = modele instanceof HTMLTemplateElement ? modele.content.querySelector('img') : null;
      if (!source) return null;
      const img = /** @type {HTMLImageElement} */ (document.importNode(source, true));
      img.dataset.mpmTeinte = index;
      img.loading = 'eager';
      img.decoding = 'async';
      const marquer = () => img.setAttribute('data-mpm-charge', '');
      if (img.complete && img.naturalWidth > 0) marquer();
      else {
        img.addEventListener('load', marquer, { once: true });
        img.addEventListener('error', marquer, { once: true });
      }
      calque.append(img);
      return img;
    };

    /** @param {Element} carte */
    const calqueDe = (carte) => {
      const calque = carte.querySelector('.card-gallery .mpm-carte-teinte');
      return calque instanceof HTMLElement ? calque : null;
    };

    /**
     * Charge à l'avance les photos des autres couleurs d'une carte.
     * @param {HTMLElement} calque
     */
    const preparerCalque = (calque) => {
      if (calque.dataset.mpmPret === 'oui') return;
      calque.dataset.mpmPret = 'oui';
      for (const modele of calque.querySelectorAll('template[data-mpm-teinte]')) {
        if (modele instanceof HTMLElement && modele.dataset.mpmTeinte) photoTeinte(calque, modele.dataset.mpmTeinte);
      }
    };

    /** @param {Element} carte */
    const preparer = (carte) => {
      const calque = calqueDe(carte);
      if (calque) preparerCalque(calque);
    };

    /**
     * Passe la carte à la couleur de la bulle, tout de suite : sa photo devient la photo visible (au-dessus des
     * autres) et apparaît en fondu dès qu'elle est chargée ; la photo précédente reste dessous jusque-là, sans
     * retour à la photo de départ entre les deux. Sans modèle (c'est la photo de la carte), le calque s'efface.
     * @param {HTMLElement} calque
     * @param {string} index
     */
    const montrerTeinte = (calque, index) => {
      const monJeton = String(++jeton);
      calque.dataset.mpmJeton = monJeton;
      const visibles = () => Array.from(calque.querySelectorAll(':scope > img.mpm-est-visible'));
      const img = photoTeinte(calque, index);

      if (!img) {
        for (const autre of visibles()) autre.classList.remove('mpm-est-visible');
        return;
      }

      niveau += 1;
      img.style.zIndex = String(niveau);
      void window.getComputedStyle(img).opacity;
      img.classList.add('mpm-est-visible');

      quandChargee(img, () => {
        window.setTimeout(() => {
          if (calque.dataset.mpmJeton !== monJeton) return;
          for (const autre of visibles()) if (autre !== img) autre.classList.remove('mpm-est-visible');
        }, DUREE_FONDU + 40);
      });
    };

    /**
     * 2e photo au survol : celle de la couleur choisie, ou aucune si cette couleur n'en a pas.
     * @param {HTMLElement} galerie
     * @param {HTMLElement} calque
     * @param {string} index
     */
    const majSurvol = (galerie, calque, index) => {
      const survol = calque.parentElement ? calque.parentElement.querySelector(':scope > .mpm-carte-survol') : null;
      if (!(survol instanceof HTMLElement)) return;
      const modele = calque.querySelector(`template[data-mpm-survol="${index}"]`);
      const source = modele instanceof HTMLTemplateElement ? modele.content.querySelector('img') : null;
      if (!source) {
        galerie.removeAttribute('data-mpm-survol');
        return;
      }
      let photos = photosSurvol.get(survol);
      if (!photos) {
        photos = new Map();
        photosSurvol.set(survol, photos);
      }
      let img = photos.get(index);
      if (!img) {
        img = /** @type {HTMLImageElement} */ (document.importNode(source, true));
        photos.set(index, img);
      }
      if (survol.firstElementChild !== img || survol.childElementCount !== 1) survol.replaceChildren(img);
      galerie.setAttribute('data-mpm-survol', '');
    };

    /**
     * Liens de la carte (fond, photo, titre) vers ?variant= de la couleur.
     * @param {Element} carte
     * @param {string} variante
     */
    const majLiens = (carte, variante) => {
      if (!/^\d+$/.test(variante)) return;
      const horizon = /** @type {any} */ (carte);
      if (typeof horizon.applyVariantToLinks === 'function') {
        try {
          horizon.applyVariantToLinks(variante);
          return;
        } catch (erreur) {
          /* repli ci-dessous */
        }
      }
      for (const lien of carte.querySelectorAll('a[href]')) {
        if (!(lien instanceof HTMLAnchorElement) || lien.closest('quick-add-component')) continue;
        const url = new URL(lien.href, window.location.href);
        if (!url.pathname.includes('/products/')) continue;
        url.searchParams.set('variant', variante);
        lien.href = url.toString();
      }
    };

    /**
     * Ajout rapide direct (carte filtrée d'un produit à une seule option) : il ajoute la couleur choisie ; si elle
     * est épuisée, le bouton ouvre la fenêtre de choix. Sinon rien à faire : la fenêtre suit le lien de la carte.
     * @param {Element} carte
     * @param {HTMLInputElement} champ
     */
    const majAjoutRapide = (carte, champ) => {
      const ajout = carte.querySelector('quick-add-component');
      if (!(ajout instanceof HTMLElement) || ajout.dataset.rendersBothButtons !== 'true') return;
      const identifiant = ajout.querySelector('form input[name="id"]');
      if (champ.dataset.mpmDispo === 'true' && identifiant instanceof HTMLInputElement) {
        identifiant.value = champ.dataset.mpmVariante || identifiant.value;
        identifiant.disabled = false;
        ajout.dataset.quickAddButton = 'add';
      } else {
        ajout.dataset.quickAddButton = 'choose';
      }
    };

    /** @param {HTMLInputElement} champ */
    const activer = (champ) => {
      const rangee = champ.closest('.mpm-bulles');
      const carte = champ.closest('product-card');
      if (!(rangee instanceof HTMLElement) || !carte) return;
      if (!champ.checked) champ.checked = true;
      const index = champ.dataset.mpmIndex || '';
      if (rangee.dataset.mpmActive === index) return;
      rangee.dataset.mpmActive = index;

      majLiens(carte, champ.dataset.mpmVariante || '');
      majAjoutRapide(carte, champ);

      const galerie = carte.querySelector('.card-gallery');
      const calque = calqueDe(carte);
      if (galerie instanceof HTMLElement && calque) {
        majSurvol(galerie, calque, index);
        montrerTeinte(calque, index);
      }
    };

    document.addEventListener('change', (event) => {
      const champ = event.target;
      if (!(champ instanceof HTMLInputElement) || champ.type !== 'radio' || !champ.checked) return;
      if (champ.classList.contains('mpm-bulle__champ')) activer(champ);
      else if (champ.closest('.mpm-couleur')) majLibelle(champ);
    });

    /* Souris : survoler une carte charge les autres couleurs ; survoler une bulle passe à la couleur de CETTE
       bulle (celle sous le pointeur). mouseover aussi, mais seulement avec une souris : sur écran tactile, le
       toucher passe par le bouton radio (sinon Safari iOS pourrait demander un 2e toucher pour ouvrir la fiche).
       Seule une vraie arrivée sur la bulle compte : quand la page change sous une souris immobile, Chrome renvoie
       un survol de la bulle déjà survolée (cible liée = cette même bulle), qui ne doit pas annuler un choix fait
       au clavier ou au clic sur une autre bulle. */
    const souris = window.matchMedia('(hover: hover) and (pointer: fine)');
    /** @param {Event} event */
    const survoler = (event) => {
      if (!(event.target instanceof Element)) return;
      if (event.type === 'pointerover' && /** @type {PointerEvent} */ (event).pointerType === 'touch') return;
      if (event.type === 'mouseover' && !souris.matches) return;
      const carte = event.target.closest('product-card');
      if (!carte) return;
      preparer(carte);
      const bulle = event.target.closest('.mpm-bulle');
      if (!bulle) return;
      const venu = /** @type {MouseEvent} */ (event).relatedTarget;
      if (venu instanceof Node && bulle.contains(venu)) return;
      const champ = bulle.querySelector('.mpm-bulle__champ');
      if (champ instanceof HTMLInputElement) activer(champ);
    };
    document.addEventListener('pointerover', survoler, { passive: true });
    document.addEventListener('mouseover', survoler, { passive: true });

    /* Toucher : les photos commencent à charger dès l'appui sur une bulle */
    document.addEventListener(
      'pointerdown',
      (event) => {
        if (!(event.target instanceof Element) || !event.target.closest('.mpm-bulles')) return;
        const carte = event.target.closest('product-card');
        if (carte) preparer(carte);
      },
      { passive: true }
    );

    /* Photos des autres couleurs chargées quand le navigateur est libre, pour les cartes proches de l'écran
       (aussi celles ajoutées ensuite : filtres, pages suivantes, « Découvrez également ») ; pas en économie
       de données. Le survol d'une bulle montre alors la photo tout de suite. */
    const economie = Boolean(/** @type {any} */ (navigator).connection && /** @type {any} */ (navigator).connection.saveData);
    if (!economie && 'IntersectionObserver' in window) {
      const quandLibre = (/** @type {() => void} */ rappel) =>
        'requestIdleCallback' in window ? window.requestIdleCallback(rappel, { timeout: 1500 }) : window.setTimeout(rappel, 300);
      const vue = new IntersectionObserver(
        (entrees) => {
          for (const entree of entrees) {
            if (!entree.isIntersecting) continue;
            vue.unobserve(entree.target);
            const calque = entree.target;
            if (calque instanceof HTMLElement) quandLibre(() => calque.isConnected && preparerCalque(calque));
          }
        },
        { rootMargin: '200px 0px' }
      );
      /** @param {Element | Document} racine */
      const surveiller = (racine) => {
        const calques = racine instanceof Element && racine.matches('.mpm-carte-teinte') ? [racine] : racine.querySelectorAll('.mpm-carte-teinte');
        for (const calque of calques) {
          if (!(calque instanceof HTMLElement) || calque.dataset.mpmVu === 'oui') continue;
          calque.dataset.mpmVu = 'oui';
          vue.observe(calque);
        }
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => surveiller(document), { once: true });
      else surveiller(document);
      new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          for (const noeud of mutation.addedNodes) if (noeud instanceof Element) surveiller(noeud);
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }
  } catch(e) { console.error(e); }
})();

})();
